import { useEffect } from 'react';

import { configPayments } from 'helpers/payments';

export const usePaymentLanguage = (language: string) => {
  useEffect(() => {
    configPayments(language);
  }, [language]);
};
